import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import NivaLogo from '../../components/NivaLogo';
import { useAuth } from '../../contexts/AuthContext';
import { useLanguage } from '../../contexts/LanguageContext';
import { ROUTES } from '../../constants/routes';
import { doctorLogin } from '../services/doctorApi';

export default function DoctorLoginScreen() {
  const navigate = useNavigate();
  const { loginWithToken } = useAuth();
  const { t, language } = useLanguage();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const data = await doctorLogin({ email: email.trim(), password });
      loginWithToken(data.token, data.doctor?.full_name || '', {
        accountType: 'doctor',
        termsAccepted: true,
        mustChangePassword: false,
      });
      navigate(ROUTES.DOCTOR_PATIENTS, { replace: true });
    } catch (err) {
      setError(err.message || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="relative flex min-h-screen items-center justify-center overflow-hidden bg-gradient-to-b from-sky-50 via-white to-primary-light px-4">
      <div className="relative w-full max-w-[380px] rounded-2xl bg-surface p-8 shadow-card">
        <NivaLogo className="mb-8" />
        <h1 className="text-center text-[28px] font-bold text-slate-900">
          {language === 'ar' ? 'تسجيل دخول الطبيب' : 'Doctor sign in'}
        </h1>
        <p className="mb-6 text-center text-[15px] text-gray-500">
          {language === 'ar' ? 'عيادة خاصة' : 'Private clinic'}
        </p>
        {error && (
          <div className="mb-4 rounded-xl bg-critical-light px-4 py-3 text-sm text-critical-dark">
            {error}
          </div>
        )}
        <form onSubmit={handleSubmit} className="space-y-4">
          <input
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Email"
            className="w-full rounded-xl border border-gray-200 px-4 py-3 text-sm focus:border-primary focus:outline-none focus:ring-2 focus:ring-primary/20"
          />
          <input
            type="password"
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Password"
            className="w-full rounded-xl border border-gray-200 px-4 py-3 text-sm focus:border-primary focus:outline-none focus:ring-2 focus:ring-primary/20"
          />
          <button type="submit" disabled={loading} className="btn-primary disabled:opacity-60">
            {loading ? '…' : t('signIn')}
          </button>
        </form>
        <p className="mt-4 text-center text-sm text-gray-500">
          <Link to={ROUTES.DOCTOR_SIGNUP} className="font-medium text-primary">
            {t('doctorCreateAccount')}
          </Link>
        </p>
        <p className="mt-2 text-center text-sm text-gray-400">
          <Link to={ROUTES.LOGIN}>{t('doctorBackToEntry')}</Link>
        </p>
      </div>
    </div>
  );
}
